import { GET_PROMOTION_SETTINGS_REQUEST, GET_PROMOTION_SETTINGS_SUCCESS, GET_PROMOTION_SETTINGS_FAILURE, UPDATE_PROMOTION_SETTINGS_REQUEST, UPDATE_PROMOTION_SETTINGS_SUCCESS, UPDATE_PROMOTION_SETTINGS_FAILURE, GET_PROMO_CODES_REQUEST, GET_PROMO_CODES_SUCCESS, GET_PROMO_CODES_FAILURE } from '../constants';

export function promotionSettings(state = {}, action) {
  switch (action.type) {
    case GET_PROMOTION_SETTINGS_REQUEST:
      return {
        loading: true,
        settings: null
      };
    case GET_PROMOTION_SETTINGS_SUCCESS:
      return {
        loading: false,
        settings: action.settings
      };
    case GET_PROMOTION_SETTINGS_FAILURE:
      return {
        error: action.error
      };
    case UPDATE_PROMOTION_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
      };
    case UPDATE_PROMOTION_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: '',
        settings: action.settings
      };
    case UPDATE_PROMOTION_SETTINGS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        success: false
      };
    default:
      return state
  }
}

export function promoCodes(state = {}, action) {
  switch (action.type) {
    case GET_PROMO_CODES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_PROMO_CODES_SUCCESS:
      return {
        loading: false,
        items: action.codes.codes,
        total: action.codes.total
      };
    case GET_PROMO_CODES_FAILURE:
      return {
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
